// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Brand & Accents */
  --brand-cyan: #1490A4;
  --brand-cyan-hover: #117a8b;
  --brand-cyan-glow: rgba(20, 144, 164, 0.25);
  --brand-teal: #00D1C1;
  --brand-coral: #FF7B54;
  --brand-blue: #3b82f6;

  /* Theme Backgrounds */
  --bg-primary: #050C0F;
  --bg-surface: #0C1518;
  --bg-surface-elevated: #111e22;
  --bg-surface-card: #0e1a1e;
  --bg-surface-hover: rgba(255, 255, 255, 0.05);
  --bg-glass: rgba(255, 255, 255, 0.03);

  /* Borders */
  --border-subtle: rgba(255, 255, 255, 0.08);
  --border-medium: rgba(94, 110, 117, 0.25);
  --border-focus: #1490A4;

  /* Status Colors */
  --color-success: #10B981;
  --bg-success-subtle: rgba(16, 185, 129, 0.12);
  --border-success-subtle: rgba(16, 185, 129, 0.3);

  --color-warning: #F59E0B;
  --bg-warning-subtle: rgba(245, 158, 11, 0.12);
  --border-warning-subtle: rgba(245, 158, 11, 0.3);

  --color-danger: #EF4444;
  --bg-danger-subtle: rgba(239, 68, 68, 0.12);
  --border-danger-subtle: rgba(239, 68, 68, 0.3);

  --color-info: #0EA5E9;
  --bg-info-subtle: rgba(14, 165, 233, 0.12);
  --border-info-subtle: rgba(14, 165, 233, 0.3);

  /* Typography */
  --text-main: #FFFFFF;
  --text-secondary: #8E9BA0;
  --text-muted: #5E6E75;
  --font-family-base: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  /* Transitions & Radii */
  --radius-sm: 6px;
  --radius-md: 10px;
  --radius-lg: 16px;
  --radius-full: 9999px;
  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  --transition-normal: 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

.font-10 {
  font-size: 10px;
  font-weight: 600;
}

.font-10-normal {
  font-size: 10px;
  font-weight: 400;
}

.font-12 {
  font-size: 12px;
  font-weight: 400;
}

.font-12-bold {
  font-size: 12px;
  font-weight: 600;
}

.font-12-normal {
  font-size: 12px;
  font-weight: 500;
}

.font-14 {
  font-size: 14px;
  font-weight: 500;
}

.font-14-normal {
  font-size: 14px;
  font-weight: 400;
}

.font-14-bold {
  font-size: 14px;
  font-weight: 600;
}

.font-16 {
  font-size: 16px;
  font-weight: 600;
}

.font-16-normal {
  font-size: 16px;
  font-weight: 500;
}

.font-18 {
  font-size: 18px;
  font-weight: 600;
}

.font-18-normal {
  font-size: 18px;
  font-weight: 500;
}

.font-20 {
  font-size: 20px;
  font-weight: 700;
}

.font-20-normal {
  font-size: 20px;
  font-weight: 600;
}

.font-24 {
  font-size: 24px;
  font-weight: 600;
}

.primary-color {
  color: #fff
}

.secondary-color {
  color: #EEF2F380
}

/* Modal Responsive Overrides for Mobile Back Button */
.modal-mobile-back-btn {
  display: none;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0 8px 0 0;
}

@media (max-width: 1000px) {
  .modal-mobile-back-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-desktop-close {
    display: none !important;
  }
  
  .modal-header, .chat-modal-header {
    justify-content: flex-start !important;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,2CAA2C;EAC3C,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;;EAErB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,0BAA0B;EAC1B,6CAA6C;EAC7C,qCAAqC;;EAErC,YAAY;EACZ,0CAA0C;EAC1C,yCAAyC;EACzC,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;EACxB,6CAA6C;EAC7C,gDAAgD;;EAEhD,wBAAwB;EACxB,6CAA6C;EAC7C,gDAAgD;;EAEhD,uBAAuB;EACvB,2CAA2C;EAC3C,8CAA8C;;EAE9C,qBAAqB;EACrB,0CAA0C;EAC1C,6CAA6C;;EAE7C,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,8FAA8F;;EAE9F,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,qDAAqD;EACrD,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sCAAsC;IACtC,SAAS;EACX;AACF","sourcesContent":[":root {\n  /* Brand & Accents */\n  --brand-cyan: #1490A4;\n  --brand-cyan-hover: #117a8b;\n  --brand-cyan-glow: rgba(20, 144, 164, 0.25);\n  --brand-teal: #00D1C1;\n  --brand-coral: #FF7B54;\n  --brand-blue: #3b82f6;\n\n  /* Theme Backgrounds */\n  --bg-primary: #050C0F;\n  --bg-surface: #0C1518;\n  --bg-surface-elevated: #111e22;\n  --bg-surface-card: #0e1a1e;\n  --bg-surface-hover: rgba(255, 255, 255, 0.05);\n  --bg-glass: rgba(255, 255, 255, 0.03);\n\n  /* Borders */\n  --border-subtle: rgba(255, 255, 255, 0.08);\n  --border-medium: rgba(94, 110, 117, 0.25);\n  --border-focus: #1490A4;\n\n  /* Status Colors */\n  --color-success: #10B981;\n  --bg-success-subtle: rgba(16, 185, 129, 0.12);\n  --border-success-subtle: rgba(16, 185, 129, 0.3);\n\n  --color-warning: #F59E0B;\n  --bg-warning-subtle: rgba(245, 158, 11, 0.12);\n  --border-warning-subtle: rgba(245, 158, 11, 0.3);\n\n  --color-danger: #EF4444;\n  --bg-danger-subtle: rgba(239, 68, 68, 0.12);\n  --border-danger-subtle: rgba(239, 68, 68, 0.3);\n\n  --color-info: #0EA5E9;\n  --bg-info-subtle: rgba(14, 165, 233, 0.12);\n  --border-info-subtle: rgba(14, 165, 233, 0.3);\n\n  /* Typography */\n  --text-main: #FFFFFF;\n  --text-secondary: #8E9BA0;\n  --text-muted: #5E6E75;\n  --font-family-base: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\n  /* Transitions & Radii */\n  --radius-sm: 6px;\n  --radius-md: 10px;\n  --radius-lg: 16px;\n  --radius-full: 9999px;\n  --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-normal: 250ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.font-10 {\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.font-10-normal {\n  font-size: 10px;\n  font-weight: 400;\n}\n\n.font-12 {\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.font-12-bold {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.font-12-normal {\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.font-14 {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.font-14-normal {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.font-14-bold {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.font-16 {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.font-16-normal {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.font-18 {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.font-18-normal {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.font-20 {\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.font-20-normal {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.font-24 {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.primary-color {\n  color: #fff\n}\n\n.secondary-color {\n  color: #EEF2F380\n}\n\n/* Modal Responsive Overrides for Mobile Back Button */\n.modal-mobile-back-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0 8px 0 0;\n}\n\n@media (max-width: 1000px) {\n  .modal-mobile-back-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .modal-desktop-close {\n    display: none !important;\n  }\n  \n  .modal-header, .chat-modal-header {\n    justify-content: flex-start !important;\n    gap: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
